import {
  AutocompleteInput,
  ReferenceInput,
} from "react-admin";
import MuiDatePickerInput from "../../common/MuiDatePickerInput";

const filterToQuery = (searchText) => ({ all: searchText });

const accountReceivableCardFilterList = (permissions, customerFilter = {}) => {
  const customerCodeFilter = {
    ...customerFilter,
    code_options: true,
  };

  const defaultFilter = [
    <MuiDatePickerInput
      alwaysOn
      source="start_date"
      variant="outlined"
      label="mine.label.start_date"
      maxDateSource="end_date"
    />,
    <MuiDatePickerInput
      alwaysOn
      source="end_date"
      variant="outlined"
      label="mine.label.end_date"
      minDateSource="start_date"
    />,
    <ReferenceInput
      alwaysOn
      source="start_customer_id"
      reference="customers"
      filter={customerCodeFilter}
      sort={{ field: "customers.code", order: "ASC" }}
      perPage={25}
    >
      <AutocompleteInput
        resettable
        optionText="code"
        filterToQuery={filterToQuery}
        variant="outlined"
        label="mine.label.start_code"
      />
    </ReferenceInput>,
    <ReferenceInput
      alwaysOn
      source="end_customer_id"
      reference="customers"
      filter={customerCodeFilter}
      sort={{ field: "customers.code", order: "ASC" }}
      perPage={25}
    >
      <AutocompleteInput
        resettable
        optionText="code"
        filterToQuery={filterToQuery}
        variant="outlined"
        label="mine.label.end_code"
      />
    </ReferenceInput>,
    <ReferenceInput
      alwaysOn
      resettable
      source="name"
      reference="customers"
      sort={{ field: "customers.name", order: "ASC" }}
      perPage={25}
    >
      <AutocompleteInput
        resettable
        optionValue="name"
        optionText="name"
        filterToQuery={filterToQuery}
        variant="outlined"
        label="mine.label.name"
      />
    </ReferenceInput>,
  ];
  if (permissions && permissions.update_company) {
    defaultFilter.unshift(
      // defaultFilter.splice(
      // 1,
      // 0,
      <ReferenceInput
        alwaysOn
        source="company_id"
        reference="companies"
        sort={{ field: "companies.alias", order: "ASC" }}
      >
        <AutocompleteInput
          resettable
          optionText="alias"
          variant="outlined"
          label="mine.label.company"
        />
      </ReferenceInput>
    );
  }
  return defaultFilter;
};

export default accountReceivableCardFilterList;
